import Vue from "vue";
import Vuetify from "vuetify";
// import * as Sentry from "@sentry/vue";
// import { BrowserTracing } from "@sentry/tracing";
// const Sentry = require("@sentry/vue");
const App = () =>
    import ("./App");
//import vuetify from "./plugins/vuetify";
import "./scss/main.scss";
import "vuetify/dist/vuetify.min.css";
import router from "./router";
import { auth } from "../firebaseConfig";
import { store } from "./store";
import InlineSvg from "vue-inline-svg";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueI18n from "vue-i18n";
import translations from "./locales/messages";

const AudioPlayer = () =>
    import ("./components/Shared/AudioPlayer.vue");
const devMode = process.env.NODE_ENV === "development";

// !devMode &&
//   Sentry.init({
//     Vue,
//     dsn:
//       "https://1a2e38150dde45699cc408a84606ba3c@o530922.ingest.sentry.io/4504604031647744",
//     integrations: [
//       //  new BrowserTracing({
//       //    routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       //    tracePropagationTargets: ["meduberet-staging-2.web.app", /^\//]
//       //  })
//     ],

//     tracesSampleRate: 0
//   });
// const BaseURL = "http://127.0.0.1:8000";
// const updater = async () => {
//   await CapacitorUpdater.notifyAppReady();
//   const current = await CapacitorUpdater.current();
//   console.log("POSTINGGGG");
//   const { data: server } = await axios.post(
//     BaseURL + "/api/version/get_version/"
//   );

//   if (
//     current.bundle.version === "builtin" ||
//     server.version > current.bundle.version
//   ) {
//     const version = await CapacitorUpdater.download({
//       version: server.version,
//       url: server.url
//     });

//     await CapacitorUpdater.set(version);
//   } else {
//     console.log("no need to updated");
//   }
// };
// if (Capacitor.getPlatform() !== "web") {
//   updater();
// }

library.add(fas);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(Vuetify, {
    iconfont: "faSvg",
    rtl: true,
    theme: {
        primary: "#3c65bc",
        secondary: "#76a2f3",
        gray: "#82848a"
    }
});
Vue.config.productionTip = false;

Vue.use(VueI18n);

// Create a VueI18n instance with the available languages
const i18n = new VueI18n({
    locale: localStorage.getItem("locale") || "he", // default locale
    messages: {
        en: translations.en,
        he: translations.he,
        ru: translations.ru
        // Add more languages and translations as needed
    }
});


Vue.component("inline-svg", InlineSvg);
Vue.component("app-audio-player", AudioPlayer);
/* eslint-disable no-new */
new Vue({
  i18n,
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App },
  mounted() {}
  //   // auth.onAuthStateChanged(user => {
  //   //   if (user) {
  //   //     this.$store.dispatch("autoSignIn", user);
  //   //   }
  //   // });
  // }
});



// WEBPACK FOOTER //
// ./src/main.js